import { Helmet } from "react-helmet-async";

export const SITE = "https://ghostthegrid.com";
const DEFAULT_IMG = `${SITE}/favicon.png`;

/**
 * Per-route SEO/GEO/AXO head: title, meta, canonical, OpenGraph, Twitter, and JSON-LD.
 * @param jsonLd  a schema object or array of objects (rendered as application/ld+json)
 */
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const url = `${SITE}${path}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}
      {/* OpenGraph */}
      <meta property="og:site_name" content="Ghost The Grid" />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
